import { Exception, SchedulerConfiguration, SchedulerRule } from "api/emailScheduler";
import {
    createDefaultRuleDefaultFormValues,
    ActionViewModel,
    CreateEmailSchedulerRuleForm,
} from "validation/components/EmailScheduler/emailSchedulerFormRules";
import { SchedulerExceptionForm } from "validation/components/EmailScheduler/exceptionsFormRules";
import { remapFilters, remapViewFilters } from "./ulits.factory";

const HOUR_IN_SECONDS = 3600;
const DAY_IN_HOURS = 24;
const MINUTE_IN_SECONDS = 60;

export const initialStatuses = [
    { name: "Booked", value: "-4" },
    { name: "Contact customer", value: "530" },
    { name: "Internal proof", value: "517" },
    { name: "Picked up", value: "578" },
];

const calculateDeadline = (days = "0", hours = "0", minutes = "0") => {
    return (
        parseInt(days) * HOUR_IN_SECONDS * DAY_IN_HOURS +
        parseInt(hours) * HOUR_IN_SECONDS +
        parseInt(minutes) * MINUTE_IN_SECONDS
    );
};

/**
 * Creates scheduler overview configuration view model
 * @param payload
 */
export const buildEmailSchedulerConfigsViewModel = (
    payload: SchedulerConfiguration
): CreateEmailSchedulerRuleForm[] => {
    return (
        payload.data
            // TODO: temporary hardcoded
            .filter(({ behaviour }) => behaviour.type === "RequestReminder")
            .map(({ id, name, behaviour, enabled, filter, weekends, exceptions }) => {
                return {
                    general: {
                        id,
                        name,
                        initialStatuses: behaviour.initialstatuses?.split(" ").map((status) => {
                            const initialStatus = initialStatuses.find(({ value }) => value === status);

                            return {
                                name: initialStatus?.name || status,
                                value: status,
                            };
                        }),
                        deadlineMaterial: behaviour.deadline,
                        weekends: weekends,
                        active: enabled,
                        order: behaviour.order,
                        exceptions:
                            exceptions?.map((exception) => {
                                return {
                                    name: exception,
                                    isChecked: true,
                                };
                            }) || [],
                    },
                    filters: remapViewFilters(filter), // filters should be always defined...
                    actions:
                        behaviour.time2deadlines?.map<ActionViewModel>(({ status, template, days, hours, minutes }) => {
                            return {
                                template: template || "",
                                status: status?.toString() || "",
                                // TODO: we need to know how to fill those values
                                startsAt: {
                                    days: days ? days.toString() : "0", // TODO: this should always exist
                                    hours: hours ? hours.toString() : "0", // TODO: this should always exist
                                    minutes: minutes ? minutes.toString() : "0", // TODO: this should always exist,
                                },
                            };
                        }) || createDefaultRuleDefaultFormValues.actions,
                };
            })
    );
};

/**
 * Create model for new rule
 * @param general
 * @param filters
 * @param actions
 */
export const buildEmailSchedulerRuleModel = ({
    general: { name, active, weekends, order, deadlineMaterial, exceptions, initialStatuses },
    filters,
    actions,
}: CreateEmailSchedulerRuleForm): SchedulerRule => {
    const filter = {
        name: name.trim(),
        enabled: active,
        weekends,
        filter: remapFilters(filters),
        behaviour: {
            deadline: deadlineMaterial,
            initialstatuses: initialStatuses?.map(({ value }) => value).join(" "),
            secondsbeforenotificationstartformanualemail: 3600, //TODO: fix, temporarily hardcoded
            order: order,
            time2deadlines: actions.map(({ startsAt: { days, hours, minutes }, status, template }) => {
                return {
                    secondsbeforedeadline: calculateDeadline(days, hours, minutes),
                    days: parseInt(days),
                    hours: parseInt(hours),
                    minutes: parseInt(minutes),
                    template,
                    status: status ? parseInt(status) : undefined,
                };
            }),
        },
    };

    if (exceptions.length) {
        return {
            ...filter,
            exceptions: exceptions.map((exception) => exception.name),
        };
    }

    return filter;
};

export const buildEmailSchedulerRuleExceptionModel = ({
    name,
    day,
    filters,
    template,
    status,
    time,
    lookHeadDays,
}: SchedulerExceptionForm): Exception => {
    return {
        name: name.trim(),
        filter: remapFilters(filters),
        behaviour: {
            day,
            time,
            template,
            lookaheaddays: parseInt(lookHeadDays),
            status: status ? parseInt(status) : undefined,
        },
    };
};

export const buildSchedulerRuleExceptionViewModel = (exceptions: Exception[]): SchedulerExceptionForm[] => {
    return exceptions.map(({ name, behaviour, filter }) => {
        return {
            name,
            filters: remapViewFilters(filter),
            template: behaviour.template || "",
            materialRequest: !!behaviour.template,
            frequency: behaviour.day ? "EVERY_WEEK" : "EVERY_DAY",
            day: behaviour.day || "",
            status: behaviour.status?.toString() || "",
            time: behaviour.time || "",
            lookHeadDays: behaviour.lookaheaddays?.toString() || "",
        };
    });
};
